import { observable } from 'mobx';
import BaseModalStore from '@src/components/modal-container/base-modal-store';
import { noop } from '@src/utils/common-util';
import PhoneCodeInputStore from '../phone-code-input/store';
import AntdMessage from '@src/components/antd/message';
import { getParameterByNames } from '@src/utils/device';
import { useEffect } from 'react';
import $$tracker from '@src/tracker';

class AppointmentModalStore extends BaseModalStore {
  phoneCodeInputStore = new PhoneCodeInputStore({
    sendCodeAsync: params => this.sendCodeAsync(params)
  });
  @observable isOpen = false;
  @observable closeCallback = noop;
  @observable type = 1; // 1-手机号预约 2-扫码预约
  @observable agree = false;
  @observable device_id = '';
  @observable qrcodeImg = ''; // 登录二维码
  @observable pc_login_token = ''; // 接口返回token
  @observable effective_time = 0; // 二维码过期时间
  @observable currentChannel = [];
  @observable
  channel = [
    { id: 1, code: 'Android', name: '安卓' },
    { id: 2, code: 'iOS', name: '苹果' },
    { id: 3, code: 'PC', name: '电脑' },
    { id: 4, code: 'Harmony', name: '鸿蒙' }
  ];

  selectChannel = code => {
    if (this.currentChannel.includes(code)) {
      this.currentChannel = this.currentChannel.filter(item => item !== code);
    } else {
      this.currentChannel.push(code);
    }
  };

  changeType = type => {
    this.type = type;
  };

  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  /**
   * 点击关闭弹窗
   * 重写关闭事件, 补充了弹窗特定的关闭回调
   */
  onClickClose = () => {
    this.isOpen = false;
    this.isActive = false;
    this.onClose();
    this.stopQrCodeCheck();
  };

  checkAgree = () => {
    this.agree = !this.agree;
  };

  sendCodeAsync = async params => {
    return this.$ztService.getPhoneCode({
      phone: this.phone,
      ...params
    });
  };

  getOsInfo = () => {
    const userAgent = navigator.userAgent;
    if (userAgent.indexOf('Windows') !== -1) return 'Windows';
    if (userAgent.indexOf('Mac OS') !== -1) return 'MacOS';
    if (userAgent.indexOf('Android') !== -1) return 'Android';
    if (userAgent.indexOf('iPhone') !== -1 || userAgent.indexOf('iPad') !== -1) return 'iOS';
    if (userAgent.indexOf('HarmonyOS') !== -1 || userAgent.indexOf('HUAWEI') !== -1) return '楦胯挋';
    return 'Other';
  };

  submit = () => {
    if (!this.phoneCodeInputStore.phoneInputStore.value) {
      AntdMessage.error('请输入手机号');
      return;
    }
    // 正则校验手机号
    const phoneRegex = /^1[3456789]\d{9}$/;
    if (!phoneRegex.test(this.phoneCodeInputStore.phoneInputStore.value)) {
      AntdMessage.error('请输入正确的手机号');
      return;
    }
    if (!this.phoneCodeInputStore.smsInputStore.value) {
      AntdMessage.error('请输入验证码');
      return;
    }
    if (!this.agree) {
      AntdMessage.error('请先选择并同意协议');
      return;
    }
    if (!this.currentChannel.length) {
      AntdMessage.error('请选择预约渠道');
      return;
    }
    const params = {
      phone: this.phoneCodeInputStore.phoneInputStore.value,
      code: this.phoneCodeInputStore.smsInputStore.value,
      operate_from: 'gw_pc',
      platform: this.currentChannel.join(','),
      device_id: this.device_id,
      ua_os: this.getOsInfo(),
      utm_source: getParameterByNames('utm_source')
    };
    this.$ztService
      .subscribe(params)
      .then(res => {
        const channelName = this.channel
          .filter(item => this.currentChannel.includes(item.code))
          .map(item => item.name)
          .join(',');
        $$tracker.clickToReserveGame('', channelName, 'success');
        AntdMessage.success('预约成功');
        this.successCallback(1);
        this.onClickClose();
      })
      .catch(err => {
        const { message } = err?.serviceResponse;
        const channelName = this.channel.find(item => item.code === this.currentChannel)?.name || '';
        $$tracker.clickToReserveGame(message, channelName, 'fail');
        AntdMessage.info(message);
      });
  };
  // 预约成功回调
  successCallback = type => {};

  getQrCode = () => {
    const envVersion = IS_MASTER_ENV ? 'trial' : 'release';
    const page = 'pages/authorize/index';
    const dataStr = this.formatDataStr(envVersion, page);
    this.$ztService
      .getQrCode(dataStr, envVersion, page)
      .then(res => {
        this.qrcodeImg = res.img || '';
        this.pc_login_token = res.pc_login_token || '';
        this.effective_time = res.effective_time || '';
        this.startQrCodeCheck();
      })
      .catch(err => {
        const { message } = err?.serviceResponse;
        AntdMessage.info(message);
      });
  };

  @observable qrCheckInterval = null; // 二维码检查定时器
  @observable intervalCount = 2000; // 二维码检查间隔-毫秒
  @observable qrCheckCount = 0; // 二维码检查次数
  startQrCodeCheck = () => {
    this.qrCheckCount = 0;
    this.stopQrCodeCheck();
    this.qrCheckInterval = setInterval(() => {
      this.checkQrCodeStatus();
    }, this.intervalCount);
  };

  /**
   * 停止二维码检查定时器
   */
  stopQrCodeCheck = () => {
    if (this.qrCheckInterval) {
      clearInterval(this.qrCheckInterval);
      this.qrCheckInterval = null;
    }
  };

  checkQrCodeStatus = () => {
    if (!this.pc_login_token) {
      this.stopQrCodeCheck();
      return;
    }
    if (this.qrCheckCount >= (this.effective_time - 60) * 1000) {
      // 二维码过期，重新获取
      this.stopQrCodeCheck();
      this.getQrCode();
      return;
    }
    // 累加检查计数，用作阈值判断二维码过期时间
    this.qrCheckCount += this.intervalCount;

    this.$ztService
      .checkPcLoginStatus(this.pc_login_token)
      .then(res => {
        if (res.is_login === 1) {
          // 二维码已扫描，预约成功
          this.successCallback(2);
          this.onClickClose();
        }
      })
      .catch(err => {
        const { message } = err?.serviceResponse;
        AntdMessage.info(message);
      });
  };

  formatDataStr = (envVersion, page) => {
    const platform = 'gw_miniprogram';
    const eventid = 'btForm';
    const utmSource = getParameterByNames('utm_source') || '';
    const _btcode = getParameterByNames('_btcode ') || '';
    const bdVid = getParameterByNames('bdVid ') || '';
    const currentUrl = window.location.href;
    const deviceId = this.device_id;
    const dataStr = [platform, eventid, utmSource, _btcode, bdVid, currentUrl, `${deviceId}&env_version=${envVersion}&page=${page}`];
    return dataStr.join('+');
  };
  use() {
    // super.use();

    useEffect(
      () => {
        if (this.isOpen) {
          if (this.type === 2) {
            this.getQrCode();
          } else {
            this.stopQrCodeCheck();
          }
        } else {
          this.stopQrCodeCheck();
        }
      },
      [this.type, this.isOpen]
    );
  }
}

export default AppointmentModalStore;
